const CanselIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 4C12.954 4 4 12.954 4 24C4 35.046 12.954 44 24 44C35.046 44 44 35.046 44 24C44 12.954 35.046 4 24 4ZM31.561 29.439C32.147 30.025 32.147 30.974 31.561 31.56C31.268 31.854 30.884 32 30.5 32C30.116 32 29.732 31.854 29.439 31.561L24 26.121L18.561 31.56C18.268 31.854 17.884 32 17.5 32C17.116 32 16.732 31.854 16.439 31.561C15.853 30.975 15.853 30.026 16.439 29.44L21.879 24L16.44 18.561C15.854 17.975 15.854 17.026 16.44 16.44C17.026 15.854 17.975 15.854 18.561 16.44L24 21.879L29.439 16.44C30.025 15.854 30.974 15.854 31.56 16.44C32.146 17.026 32.146 17.975 31.56 18.561L26.121 24L31.561 29.439Z"
        fill="#E2E2E2"
      />
    </svg>
  );
};

export default CanselIcon;
